import { ECAPI_TYPE_CAPSULE } from '@kissui/helpers/src/catalog'
export const renderPrice = ({
    price,
    hidePrice,
    giftcard_price,
    price_per_capsule,
    show_sleeve_price,
    type
}) => {
    if ((!price && !giftcard_price) || hidePrice) {
        return ''
    }
    let finalPrice = null
    if (!show_sleeve_price && price_per_capsule) {
        finalPrice = price_per_capsule
    } else {
        finalPrice = price
    }
    if (type !== ECAPI_TYPE_CAPSULE) {
        finalPrice = price
    }

    return `<p class="cb-price-current"><span>${finalPrice || giftcard_price}</span></p>`
}
